module.exports = __webpack_public_path__ + "img/extended.c33e940a.png";